import React from "react";
import DirectusCombobox from "./combobox";
import EvtMultiSelectBadges from "../multiselect";
import client from "directus/src/client";
import FilterWrapper from "components/filter/wrapper";

export default function TitleCombobox({
  filter,
  hideLabel,
  className,
  multiselect = false,
  ...props
}) {
  // If multiselect is enabled, use the multiselect component
  if (multiselect) {
    if (hideLabel) {
      return (
        <div className={className}>
          <EvtMultiSelectBadges
                  collection="job_titles"
            fields={["id", "name"]}
            searchKeys={["name"]}
            filter={filter}
            placeholder="Select"
            {...props}
          />
        </div>
      );
    }

    return (
      <FilterWrapper label="Job Title" className={className}>
        <EvtMultiSelectBadges
          collection="job_titles"
          fields={["id", "name"]}
          searchKeys={["name"]}
          filter={filter}
          placeholder="Select"
          {...props}
        />
      </FilterWrapper>
    );
  }

  // Default single select behavior
  if (hideLabel) {
    return (
      <div className={className}>
        <DirectusCombobox
          client={client}
          collection="job_titles"
          fields={["id", "name"]}
          searchKeys={["name"]}
          filter={filter}
          placeholder="Select Job Title"
          {...props}
        />
      </div>
    );
  }

  return (
    <FilterWrapper label="Job Title" className={className}>
      <DirectusCombobox
        client={client}
        collection="job_titles"
        fields={["id", "name"]}
        searchKeys={["name"]}
        filter={filter}
        {...props}
      />
    </FilterWrapper>
  );
}
